/**
 * @Desc: 商品列表页静态数据
 * @Date: 2021-10-18 11:10
 * @Last Modified by: p_yufangyin
 * @Last Modified time: 2021-10-18 16:48
 */

import { goodsType } from '@/constants/goods';

// 商品状态
export const STATE_EUNM = {
  online: {
    text: '已上架',
    className: 'processing',
    operateName: '下架',
  },
  offline: {
    text: '未上架',
    className: 'expired',
    operateName: '上架',
  },
};

// 商品列表-表格列
export const GOODLIST_COLUMS = [
  {
    title: '商品id',
    dataIndex: 'uuid',
    width: 180,
  },
  {
    title: '商品名称',
    dataIndex: 'name',
    ellipsis: true,
    width: 250,
  },
  {
    title: '商品类型',
    dataIndex: 'type_name',
  },
  {
    title: '商品属性',
    dataIndex: 'kind_name',
  },
  {
    title: '所需积分',
    dataIndex: 'score',
  },
  {
    title: '库存',
    dataIndex: 'total_stock',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '更新时间',
    dataIndex: 'update_time',
    width: 200,
  },
  {
    title: '修改人',
    dataIndex: 'operator',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    fixed: 'right',
  },
];

// 表单查询
export const FIELD_SOURCE = [
  {
    name: 'name',
    label: '商品名称',
    type: 'input',
    placeholder: '请输入内容',
    span: 8,
  },
  {
    name: 'type',
    label: '商品类型',
    type: 'select',
    options: goodsType,
    span: 8,
  },
  {
    name: 'score',
    label: '所需积分',
    slot: 'score',
    span: 8,
  },
  {
    name: 'status',
    label: '状态',
    type: 'select',
    options: [
      {
        value: 'online',
        label: '已上架',
      },
      {
        value: 'offline',
        label: '未上架',
      },
    ],
    span: 8,
  },
  {
    name: 'total_stock',
    label: '库存',
    slot: 'total_stock',
    span: 8,
  },
  {
    name: 'action_time',
    label: '更新时间',
    type: 'range-picker',
    span: 8,
  },
];

// 变更类型
export const CHANGE_TYPE = [
  {
    label: '用户下单',
    value: 'new_order',
  },
  {
    label: '订单取消',
    value: 'order_cancel',
  },
  {
    label: '库存调整',
    value: 'stock_eidt',
  },
];

// 变更记录-表格列
export const CHANGE_TYPE_COLUMS = [
  {
    title: '变更类型',
    dataIndex: 'action',
  },
  {
    title: '操作人u_id',
    dataIndex: 'creator_uid',
  },
  {
    title: '操作人姓名',
    dataIndex: 'creator',
  },
  {
    title: '属性',
    dataIndex: 'attr',
  },
  {
    title: '变更数量',
    dataIndex: 'change_num',
  },
  {
    title: '变更后库存',
    dataIndex: 'after_change_num',
  },
  {
    title: '订单号',
    dataIndex: 'order_uuid',
  },
  {
    title: '更新时间',
    dataIndex: 'update_time',
  },
];

// 变更记录-测试数据
export const TEST_DATA = [
  {
    action: 'new_order',
    creator_uid: 'p_sanzhang',
    creator: '张三',
    change_num: 10,
    after_change_num: 40,
    order_uuid: '432432',
    update_time: '2021-08-14 16:31:20',
  },
  {
    action: 'order_cancel',
    creator_uid: 'p_dahaiwang',
    creator: '王大海',
    change_num: 10,
    after_change_num: 40,
    order_uuid: '432432',
    update_time: '2021-08-14 16:31:20',
  },
  {
    action: 'stock_eidt',
    creator_uid: 'p_dahaiwang',
    creator: '王大海',
    change_num: 10,
    after_change_num: 40,
    order_uuid: '432432',
    update_time: '2021-08-14 16:31:20',
  },
];

// 各规格库存-表格列
export const SPECS_COLUMS = [
  {
    title: '颜色',
    dataIndex: 'action',
  },
  {
    title: '尺寸',
    dataIndex: 'creator_uid',
  },
  {
    title: '现有库存',
    dataIndex: 'creator',
  },
];
